import React, { useImperativeHandle, forwardRef } from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

interface IProps {
  onQuery?: (value: any) => void;
}

const QueryForm = ({ onQuery }: IProps, ref: any) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log('Submitted values:', values); // 添加日志以检查提交的值
    if (typeof onQuery === 'function') {
      onQuery(values);
    }
  };

  const onReset = () => {
    form.resetFields();
    if (typeof onQuery === 'function') {
      onQuery({});
    }
  };

  useImperativeHandle(ref, () => ({
    resetQuery: onReset,
    submitQuery: () => form.submit(),
  }));

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onFinish}
      labelCol={{ span: 6 }}
      labelAlign="left"
      autoComplete="off"
    >
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item label={t('dict.itemId')} name="conceptId">
            <Input placeholder={t('ikg.input',{name:t('dict.itemId')})}/>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.conceptCode')} name="conceptCode">
            <Input placeholder={t('ikg.input',{name:t('dict.conceptCode')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.name')} name="conceptName">
            <Input placeholder={t('ikg.input',{name:t('dict.name')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.classType')} name="conceptClassName">
            <Input placeholder={t('ikg.input',{name:t('dict.classType')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.conceptType')} name="standardConcept">
            <Input placeholder={t('ikg.input',{name:t('dict.conceptType')})} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label={t('dict.conceptDomain')} name="domainName">
            <Input placeholder={t('ikg.input',{name:t('dict.conceptDomain')})} />
          </Form.Item>
        </Col>
        <Col span={8}></Col>
        <Col span={24}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 16,
            }}
          >
            <Button onClick={onReset}>{t('ikg.reset')}</Button>
            <Button type="primary" onClick={() => form.submit()} ghost>
              {t('ikg.query')}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default forwardRef(QueryForm);
